import { jsx as n } from "react/jsx-runtime";
import { Spinner as t } from "@chakra-ui/react";
const p = ({ size: r = "md", ...o }) => /* @__PURE__ */ n(t, { size: r, ...o });
export {
  p as LoadingIndicator
};
